import React from "react";
import { FullScreenPermissionsError } from "../Common/InsufficientPermissions";
import { AuthContext } from "./AuthContext";
import { AuthContextType } from "./types";

export type PermissionOptions = Parameters<AuthContextType["authorized"]>[0];

export const withAuthorization = <P extends {}>(
  WrappedComponent: React.ComponentType<P>,
  permissionOptions: PermissionOptions,
) => {
  return (props: P) => {
    const { authorized } = React.useContext(AuthContext);

    return authorized(permissionOptions) ?
        <WrappedComponent {...props} />
      : <FullScreenPermissionsError />;
  };
};
